import styled, { keyframes } from 'styled-components';

const shine = keyframes`
    0% {
        left: -200px;
    }
    100% {
        left: calc(100% + 200px)
    }
`;

export const SkeletonAnimation = styled.div`
    height: 100%;
    width: 200px;
    background: ${({ gray }) =>
        gray
            ? 'linear-gradient(90deg, transparent 0%, #dfe5ed 50%, transparent 100%);'
            : 'linear-gradient(90deg, transparent 0%, #fff 50%, transparent 100%);'};
    animation: ${shine} 1.5s infinite linear;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
`;
